import { useState } from 'react';
import axios from 'axios';

const API = '/api';

function ImportInvestmentCSV({ onImported }) {
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState('');

  const handleUpload = async () => {
    if (!file) return;
    setStatus('Importing...');
    const formData = new FormData();
    formData.append('csv', file);
    try {
      const res = await axios.post(`${API}/import/investments/csv`, formData);
      const { imported, skipped } = res.data;
      setStatus(`✓ Imported ${imported} transactions${skipped > 0 ? ` · ${skipped} duplicates skipped` : ''}`);
      onImported();
    } catch (err) {
      setStatus('Error: ' + (err.response?.data?.error || err.message));
    }
  };

  return (
    <div className="import-wrap">
      <div className="form-title">Import Investment CSV</div>
      <div className="import-zone">
        <input type="file" accept=".csv,.txt" onChange={e => setFile(e.target.files[0])} />
        {file && <div className="import-filename">{file.name}</div>}
        <p>Expected columns: Date, Reference, Type, Description, Debit $, Credit $, Balance $</p>
      </div>
      <button className="btn-primary" onClick={handleUpload} disabled={!file}>Import</button>
      {status && <div className="status-msg">{status}</div>}
    </div>
  );
}

export default ImportInvestmentCSV;